import { Badge, Button, DefaultPopover } from 'twyne-new.ui'

export default function PlacementModified({ show, onRestore }) {
  if (!show) {
    return null
  }

  return <DefaultPopover
    title='Placement Modified'
    trigger={<Badge
      size='sm'
      variant='light'
      color='warning'
      className='self-center cursor-pointer transition-colors twy-bg-warning-hover hover:text-white'
    >
      Placement Modified
    </Badge>}
    triggerProps={{ asChild: true }}
  >
    <div className='flex flex-col gap-4'>
      <span>
        The content of the placement has been modified in the Advanced tab. To restore to the original generated placement, click the restore button below. All customizations will be lost.
      </span>
      <Button block color='accent' onClick={onRestore}>
        Restore Standard Placement
      </Button>
    </div>
  </DefaultPopover>
}
